import PropTypes from "prop-types";
import React from "react";
import { useLocation } from "react-router-dom";

// The context for the menu. The button for the menu is shown if the openable
// value is True. `openable` is set by the `setOpenable` function The menu
// itself is shown if the `isOpen` value is True. The value of `isOpen` is
// inverted when toggle is called
const Context = React.createContext({
	isOpen: false,
	openable: false,
	setOpenable: () => {},
	toggle: () => {}
});

// The implentation of the functions for the MenuContext
export function MenuProvider({
	children,
}) {
	const [ isOpen, setOpen ] = React.useState(false);
	const [ openable, setOpenable ] = React.useState(false);
	const toggle = React.useCallback(() => setOpen(isOpen => !isOpen), []);

	// Close on navigation
	const { pathname } = useLocation();
	React.useEffect(() => {
		setOpen(false);
	}, [pathname]);

	return <Context.Provider value={ { isOpen, toggle, openable, setOpenable } }>
		{ children }
	</Context.Provider>;
}

MenuProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

// The Button that activates the menu. It's filled when openable is true
export function MenuButton() {
	const { isOpen, openable, toggle } = React.useContext(Context);

	return <div
		className={ `wz-burger${ isOpen ? " open" : "" }` }
		onClick={ toggle }
	>
		{ openable && <div className="wz-burgerctnt" /> }
	</div>;
}

// The container of the menu. It's open when isOpen in the context is true
export function MenuWrapper({
	children,
}) {
	const { setOpenable, isOpen } = React.useContext(Context);

	// When the wrapper is mounted and unmount, notify it to the MenuButton
	// through the context
	React.useEffect(() => {
		setOpenable(true);
		return () => {
			setOpenable(false);
		};
	// eslint-disable-next-line
	}, []);

	// When the Wrapper is open, add the wz-menu to the body in order to
	// work arround a scroll bar bug
	React.useEffect(() => {
		if (isOpen) {
			document.body.classList.add("wz-menu");
		} else {
			document.body.classList.remove("wz-menu");
		}
	}, [isOpen]);


	return <div className={ `wz-leftmenu${isOpen ? " open" : "" }` }>
		<div className="wz-leftmenu-content">
			{ children }
		</div>
	</div>;
}
MenuWrapper.propTypes = {
	children: PropTypes.node.isRequired,
};
